import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { ChevronRight } from 'lucide-react';
import { sbg } from '../../../theme/sbgTokens';

/**
 * Technical detail an operator can expand (book §11.15): a native
 * <details> disclosure, closed by default, so raw messages such as
 * "Request failed with status code 500" never lead the error copy.
 * Inherits its color so it reads on white surfaces and inside tinted alerts.
 */
const ErrorDetails: React.FC<{ detail?: string | null; sx?: SxProps<Theme> }> = ({ detail, sx }) => {
  if (!detail) return null;
  return (
    <Box
      component="details"
      sx={{
        mt: 0.5,
        color: 'inherit',
        '& > summary': {
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          cursor: 'pointer',
          listStyle: 'none',
          font: 'var(--sbg-type-label-xs)',
          borderRadius: sbg.radius.sm,
          '&::-webkit-details-marker': { display: 'none' },
          '&:focus-visible': { outline: `2px solid ${sbg.focus.ring}`, outlineOffset: '2px' },
          '& > svg': { transition: `transform ${sbg.duration.fast} ${sbg.ease.standard}` },
        },
        '&[open] > summary > svg': { transform: 'rotate(90deg)' },
        ...sx,
      }}
    >
      <summary>
        <ChevronRight size={14} aria-hidden="true" />
        Details
      </summary>
      <Box component="p" sx={{ m: 0, mt: 0.5, font: 'var(--sbg-type-mono-sm)', overflowWrap: 'anywhere' }}>
        {detail}
      </Box>
    </Box>
  );
};

export default ErrorDetails;
